import clsx from 'clsx';
import { statusPalette } from '@/utils/format.js';

export default function StatusBadge({ status, label, className }) {
  const palette = statusPalette(status);
  const text    = label ?? (status ? String(status).replace(/_/g, ' ') : '—');

  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset',
        palette.bg, palette.text, palette.ring,
        className,
      )}
    >
      <span className={clsx('h-1.5 w-1.5 rounded-full', palette.text.replace('text', 'bg'))} aria-hidden />
      <span className="capitalize">{text}</span>
    </span>
  );
}
